
import { Badge } from "@/components/ui/badge";
import { format } from "date-fns";

interface BundleMonthTagProps {
  bundleStartDate?: string;
  startDate?: string; // Legacy prop for compatibility
  tagType?: 'current' | 'expired' | 'upcoming';
  bundleTitle?: string | null;
  className?: string;
}

export function BundleMonthTag({ bundleStartDate, startDate, tagType = 'current', bundleTitle, className = "" }: BundleMonthTagProps) {
  // Check if this is a Funbox book
  const isFunbox = bundleTitle?.toLowerCase() === 'funbox';
  
  // Use startDate if bundleStartDate is not provided (for compatibility)
  const dateToUse = bundleStartDate || startDate;
  let displayText: string;
  let bgColor: string;
  let borderColor: string;
  let showNewTag = false;
  
  if (isFunbox) {
    // Funbox books show "New FunBox" with dark solid style
    displayText = 'New FunBox';
    bgColor = 'rgba(20, 20, 25, 0.95)'; // Solid dark
    borderColor = 'rgba(255, 255, 255, 0.15)';
    showNewTag = false;
  } else if (tagType === 'upcoming') {
    // Only books in upcoming bundle show COMING SOON
    displayText = 'Coming soon';
    bgColor = 'rgba(37, 99, 235, 0.95)'; // Solid blue
    borderColor = 'rgba(147, 197, 253, 0.4)';
  } else if (dateToUse) {
    // All other books show their month/year
    const date = new Date(dateToUse);
    const month = format(date, 'MMM');
    const year = date.getFullYear().toString().slice(-2);
    displayText = `${month} ${year}`;
    bgColor = 'rgba(200, 50, 50, 0.95)'; // Solid red
    borderColor = 'rgba(252, 165, 165, 0.4)';
  } else {
    return null;
  }
  
  return (
    <div className={`absolute -bottom-px left-1/2 -translate-x-1/2 z-10 ${className}`}>
      {showNewTag && (
        <Badge
          variant="secondary"
          className="text-white text-[7px] md:text-[10px] font-figtree font-bold px-2 py-0.5 mb-1 shadow-lg whitespace-nowrap"
          style={{
            background: 'rgba(20, 20, 25, 0.95)',
            border: '1px solid rgba(255, 255, 255, 0.15)',
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
            borderRadius: '6px'
          }}
        >
          NEW
        </Badge>
      )}
      <Badge
        variant="secondary"
        className="text-white text-[7px] md:text-xs font-figtree font-bold px-2 py-0.5 md:px-3 md:py-1 shadow-lg whitespace-nowrap"
        style={{
          background: bgColor,
          border: `1px solid ${borderColor}`,
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
          borderRadius: '8px 8px 0 0'
        }}
      >
        {displayText}
      </Badge>
    </div>
  );
}
